import React, { useState } from 'react';
import { ArrowRight, Upload } from 'lucide-react';
import Hero from '../components/Hero';
import './Quote.css';

const Quote = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    companyName: '',
    email: '',
    phone: '',
    service: '',
    origin: '',
    destination: '',
    cargoType: '',
    cargoDescription: '',
    weight: '',
    dimensions: '',
    volume: '',
    shippingDate: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="quote">
        <Hero
          title="Request a Quote"
          subtitle="Tell us what you need to move. We'll help you find the right logistics solution."
          size="small"
          image="/img/quote-hero.jpg"
        />
        <section className="section">
          <div className="container">
            <div className="quote-success">
              <div className="quote-success__icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                  <circle cx="32" cy="32" r="32" fill="rgba(13,148,136,0.1)" />
                  <path d="M20 32L28 40L44 24" stroke="var(--teal)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h2>Thank You!</h2>
              <p>Your quote request has been submitted successfully. Our team will review your requirements and get back to you shortly.</p>
              <button onClick={() => setSubmitted(false)} className="btn btn-primary">
                Submit Another Request
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="quote">
      <Hero
        title="Request a Quote"
        subtitle="Tell us what you need to move. We'll help you find the right logistics solution."
        size="small"
        image="/img/quote-hero.jpg"
      />

      <section className="section quote-form-section">
        <div className="container">
          <div className="quote-form-wrap">
            <form className="quote-form" onSubmit={handleSubmit}>
              {/* Contact Details */}
              <div className="quote-form__section">
                <h3 className="quote-form__section-title">Contact Details</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="fullName">Full Name *</label>
                    <input type="text" id="fullName" name="fullName" required value={formData.fullName} onChange={handleChange} placeholder="Your full name" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="companyName">Company Name *</label>
                    <input type="text" id="companyName" name="companyName" required value={formData.companyName} onChange={handleChange} placeholder="Your company name" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} placeholder="your@email.com" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone *</label>
                    <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" />
                  </div>
                </div>
              </div>

              {/* Shipment Details */}
              <div className="quote-form__section">
                <h3 className="quote-form__section-title">Shipment Details</h3>
                <div className="form-group">
                  <label htmlFor="service">Service Required *</label>
                  <select id="service" name="service" required value={formData.service} onChange={handleChange}>
                    <option value="">Select a service</option>
                    <option value="sea-freight">Sea Freight</option>
                    <option value="air-freight">Air Freight</option>
                    <option value="land-freight">Land Freight</option>
                    <option value="project-logistics">Project Logistics</option>
                    <option value="customs-clearance">Customs Clearance</option>
                    <option value="warehousing">Warehousing & Value-Added Services</option>
                    <option value="multimodal">Multimodal Transportation</option>
                  </select>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="origin">Origin *</label>
                    <input type="text" id="origin" name="origin" required value={formData.origin} onChange={handleChange} placeholder="City, Country" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="destination">Destination *</label>
                    <input type="text" id="destination" name="destination" required value={formData.destination} onChange={handleChange} placeholder="City, Country" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="cargoType">Cargo Type</label>
                    <input type="text" id="cargoType" name="cargoType" value={formData.cargoType} onChange={handleChange} placeholder="e.g., General, DGR, Perishable" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="shippingDate">Preferred Shipping Date</label>
                    <input type="date" id="shippingDate" name="shippingDate" value={formData.shippingDate} onChange={handleChange} />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="cargoDescription">Cargo Description</label>
                  <textarea id="cargoDescription" name="cargoDescription" rows="2" value={formData.cargoDescription} onChange={handleChange} placeholder="Brief description of your cargo"></textarea>
                </div>
                <div className="form-row form-row--3">
                  <div className="form-group">
                    <label htmlFor="weight">Weight (kg)</label>
                    <input type="text" id="weight" name="weight" value={formData.weight} onChange={handleChange} placeholder="e.g., 500" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="dimensions">Dimensions (cm)</label>
                    <input type="text" id="dimensions" name="dimensions" value={formData.dimensions} onChange={handleChange} placeholder="L x W x H" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="volume">Volume / CBM</label>
                    <input type="text" id="volume" name="volume" value={formData.volume} onChange={handleChange} placeholder="e.g., 2.5" />
                  </div>
                </div>
              </div>

              {/* Additional */}
              <div className="quote-form__section">
                <h3 className="quote-form__section-title">Additional Information</h3>
                <div className="form-group">
                  <label htmlFor="message">Message / Special Requirements</label>
                  <textarea id="message" name="message" rows="4" value={formData.message} onChange={handleChange} placeholder="Any special requirements or additional information"></textarea>
                </div>
                <div className="form-group">
                  <label>File Upload (if required)</label>
                  <div className="file-upload">
                    <Upload size={20} />
                    <span>Drag & drop files or click to browse</span>
                    <input type="file" multiple />
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary btn-lg quote-form__submit">
                Submit Enquiry <ArrowRight size={18} />
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Quote;
